import React from "react";
import styled from "styled-components";
import { AggregatedLeadHistory } from "../../LeadDetailV4";

interface IHistoryTab {
  leadId: string;
  maxHeight?: number;
}

export const HistoryTab: React.FC<IHistoryTab> = ({ leadId, maxHeight }) => {
  return (
    <Wrapper>
      <AggregatedLeadHistory leadId={leadId} maxHeight={`${maxHeight}px`} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  height: 100%;

  overflow-y: auto;
`;
